// extracted by mini-css-extract-plugin
module.exports = {"introducing-visalex":"IntroducingVisalex_introducing-visalex__asYs0","introducing-visalex__content":"IntroducingVisalex_introducing-visalex__content__fRsxR"};